import React, { useState } from 'react';
import './StockLogo.css';

const StockLogo = ({ symbol, size = 24 }) => {
  const [error, setError] = useState(false);
  const cleanSymbol = (symbol || '').trim().toUpperCase();

  return (
    <div className="stock-logo-container" style={{ width: size, height: size, minWidth: size, minHeight: size }}>
      {!error ? (
        <img 
          src={`/Stocks-Logo/Stocks-Logo/${cleanSymbol}.jpeg`} 
          alt={cleanSymbol} 
          onError={() => setError(true)}
          className="stock-logo-img"
        />
      ) : (
        <img 
          src={`https://ui-avatars.com/api/?name=${cleanSymbol}&background=random&color=fff&size=${size}&bold=true`}
          alt={cleanSymbol}
          className="stock-logo-dummy"
        />
      )}
    </div>
  );
};

export default StockLogo;
